// extracted by mini-css-extract-plugin
module.exports = {"formats":"formats_formats__ZiK3_"};